import apiFetech from "../configs/axios";
import { API_MEALS_RATE_URL } from "../constants/urls";

export class BestDishServices {
  static async getBestDish()  {
    var config = {
      method: "GET",
      url: API_MEALS_RATE_URL,
    };
    return apiFetech(config);
  }
}
